import type { ReactNode } from 'react';

import { useAuth } from '@/contexts/AuthContext';
import { Page403 } from '@/routes/system/Page403';

export type Role = 'buyer' | 'admin' | 'super_admin';

export type RequireRoleProps = {
  role: Role | Role[];
  children: ReactNode;
};

function RouteLoading() {
  return <div aria-busy="true" aria-live="polite" className="route-loading" />;
}

export function RequireRole({ role, children }: RequireRoleProps) {
  const auth = useAuth();
  const allowedRoles = Array.isArray(role) ? role : [role];

  if (auth.status === 'loading') {
    return <RouteLoading />;
  }
  if (auth.status === 'anonymous') {
    return <Page403 />;
  }
  if (!allowedRoles.includes(auth.profile.role as Role)) {
    return <Page403 />;
  }
  return <>{children}</>;
}
